import { render, staticRenderFns } from "./LeftArrow.vue?vue&type=template&id=868fbd42&scoped=true&"
import script from "./LeftArrow.vue?vue&type=script&lang=js&"
export * from "./LeftArrow.vue?vue&type=script&lang=js&"
import style0 from "./LeftArrow.vue?vue&type=style&index=0&id=868fbd42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868fbd42",
  null
  
)

export default component.exports